<template>
  <div class="flex w-full">
    <article class="card">
      <div class="card-content">
        <h3
          class="my-0"
          v-text="'No results'"
        />
      </div>
    </article>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'NoResults',
}
</script>
